export class IsDownloadingMasterDataEvent {
  constructor(public readonly isDownloading: boolean) {}
}
